import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { Box } from '@mui/system';

const StatsCard = ({ title, value, icon }) => {
  return (
    <Card sx={{ display: 'flex', alignItems: 'center', padding: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 2 }}>
        {icon}
      </Box>
      <CardContent>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" color="text.secondary">{value}</Typography>
      </CardContent>
    </Card>
  );
};

export default StatsCard;
